import React from 'react';
import Loader from '../Loader';
import { FLOWBUILDER_URL } from '../../config/console-configuration';

export default function FlowBuilder(props) {
  window.open(FLOWBUILDER_URL, '_blank');
  props.history.goBack();
  return (<Loader />);
}
